// import axios from '@/axios-mock'
import sdk from '@beastshop/sdk'

const {
  request
} = sdk

module.exports = {
  getProduct: (productId, source) => {
    let url = `/app/product/${productId}`
    if (source) {
      url = `/app/product/${productId}?source=${source}`
    }
    return request({
      url
    })
  },
  getDetail: (productId, legacy = true, nocache = false) => {
    return request({
      url: `/app/product/${productId}/details?legacy=${legacy}&nocache=${nocache}`
    })
  },

  getTags: (productId) => {
    return request({
      url: `/app/product/${productId}/tickets`
    })
  },
  getCartNum: () => {
    return request({
      url: `/app/cart/packs/size`
    })
  },
  isDistribution: (productId, districtId) => {
    return request({
      url: `/app/product/${productId}/district/${districtId}/available`
    })
  },
  addCart: (spvId, count = 1) => {
    return request({
      url: '/app/cart/packs',
      method: 'POST',
      json: [{
        spvId: spvId,
        count: count,
        source: 'RAW'
      }]
    })
  },
  orderPreview: (spvId, count = 1, orderType = 'NORMAL') => {
    return request({
      url: '/app/order/preview',
      method: 'POST',
      json: {
        pack:{
          spvId,
          count
        },
        orderType
      }
    })
  },
  favorite: (id, type = 'POST') => {
    return request({
      url: `/app/favorite/PRODUCT?id=${id}`,
      method: type
    })
  },

  foreShow : ({
    id,
    productCode,
    productName,
    reminded
  }) => {
    let url = `/app/foreshow/${productCode}`
    if (reminded) {
      url += `?id=${id}`
    }
    return request({
      url,
      json: !reminded ? {
        productName,
        id
      } : '',
      method: reminded ? 'DELETE' : 'POST'
    })
    .then(({
      code,
      data
    }) => {
      return Promise.resolve(data)
    })
    .catch(err => {
      return Promise.reject(err)
    })
  },

  getLessonDetail (productCode) {
    return request({
      url: `/app/beastLesson/course/${productCode}`
    })
  },

  reminderLesson (courseCode) {
    return request({
      url: `/app/beastLesson/${courseCode}/remind`,
      method: 'PUT'
    })
  },

  cancelReminderLesson(courseCode) {
    return request({
      url: `/app/beastLesson/${courseCode}/cancel_remind`,
      method: 'PUT'
    })
  },

  getCommentBy ({productCode, increase = 0, scene = ''}) {
    let limit = 3
    let offset = increase * limit
    return request({
      url: `/app/shareOrder/evaluate?prodCode=${productCode}&offset=${offset}&limit=${limit}&scene=${scene}`
    })
  },

  doArrival (productCode) {
    return request({
      url: `/app/product/arrival/subscribe/${productCode}`,
      method: 'PUT'
    })
  },
  
  getCouponsByProduct (productCode, productId, isGet = false) {
    return request({
      url: `/app/coupon/getProdCoupons?prodcode=${productCode}&productId=${productId}&isGet=${isGet}`
    })
  },

  getCouponByCode (couponId, prodCode) {
    return request({
      url: `/app/coupon/getProdCoupon?couponId=${couponId}&prodcode=${prodCode}`
    })
  },

  shareNotice (productCode) {
    return request({
      url: `/app/share/notice`,
      method: 'POST',
      json: {
        pageType: 'PRODUCT',
        busiParam: productCode || ''
      }
    })
  }
}



// WEBPACK FOOTER //
// ./static/app-product-detail/api.js